import React, { useState } from "react";
import "./admindashboard.css";
import loginimg from "../Assets/Img/loginsideimg.png";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const navigate = useNavigate(); // Hook to navigate between routes

  const [openModal, setOpenModal] = useState(false);
  const signupModal = () => {
    setOpenModal(true);
    localStorage.setItem("openModal", JSON.stringify(true)); // Store true in localStorage
  };
  const loginModal = () => {
    setOpenModal(false);
    localStorage.setItem("openModal", JSON.stringify(false)); // Store true in localStorage
  };
  return (
    <>
      <div className="container-login p-0 mt-5 mb-5">
        <div className="card">
          <div className="row no-gutters">
            {/* Right Side (Login and Signup Buttons) */}
            <div className="col-12 col-md-6 col-sm-12 col-xs-12 right">
              <h2>Welcome to InSocial Orbit</h2>
              <button
                type="button"
                className="btn btn-outline-success btn-lg mb-2"
                onClick={() => {
                  navigate("/phone-email");
                  loginModal();
                }}
              >
                Login
              </button>

              <button
                type="button"
                className="btn btn-outline-success btn-lg"
                onClick={() => {
                  navigate("/signUp");
                  signupModal();
                }}
              >
                Signup
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
